


























import Vue from 'vue';
import Component from 'vue-class-component';
import CheckoutElementLayout from '@/project/app/client-pages/checkout/CheckoutElementLayout.vue';
import { AddressViewObject, DeliveryAddressViewObject } from '@/types/apiServerContract';
import { Prop, Watch } from 'vue-property-decorator';
import AddressCard from '@/project/ui-components/address/AddressCard.vue';
import checkoutChangeAddressOverlayService from '@/project/modals/overlays/CheckoutChangeAddressOverlay.service';
import breakpointsState from '@/core/responsive/breakpoints/breakpointsState.observable';
import { MAX_SM } from '@/core/config/breakpointConfig';
import addressService from './address.service';
import { Validatable } from '@/project/app/client-pages/checkout/types';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';

@Component({
    components: { SpinnerOverlay, AddressCard, CheckoutElementLayout },
    model: {
        prop: 'deliveryAddress',
        event: 'deliveryAddressUpdated'
    }
})
export default class CheckoutAddressOverview extends Vue implements Validatable {
    validationError = false;

    @Prop(Object)
    invoiceAddress!: AddressViewObject;

    @Prop(Object)
    deliveryAddress!: AddressViewObject | DeliveryAddressViewObject | null;

    @Prop(Array)
    deliveryAddresses!: DeliveryAddressViewObject[];

    @Prop(Boolean)
    basketUpdateInProgress!: boolean;

    @Prop({
        type: Array,
        required: true
    })
    allowedCountryCodes!: string[];

    @Prop(Boolean)
    dataLoaded!: boolean;

    get side(): 'left' | 'center' {
        return breakpointsState.isBreakpointActive(MAX_SM) ? 'left' : 'center';
    }

    async showChangeAddressOverlay() {
        const address = await checkoutChangeAddressOverlayService.show(
            this.deliveryAddresses, this.deliveryAddress, this.allowedCountryCodes, {
                placement: this.side
            });
        if (address) {
            this.validationError = false;
            this.$emit('deliveryAddressUpdated', address);
        }
    }

    validate(): Promise<boolean> {
        const valid = !!this.deliveryAddress && this.$refs.deliveryAddress.isValid();
        this.validationError = !valid;
        return Promise.resolve(valid);
    }

    @Watch('deliveryAddresses', {
        immediate: true
    })
    onDeliveryAddressesChange(value: DeliveryAddressViewObject[]) {
        addressService.setOriginalDeliveryAddresses(value);
    }

    $refs!: Vue['$refs'] & {
        deliveryAddress: AddressCard
    }
}
